/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  createPrivateTransaction,
  getAllPrivateTransactions,
  getPrivateSampleCsv,
} from "../../../redux/features/privatetransactions/privatetransactions.js";
import PrimaryWithIconButton from "../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import CommonFileUpload from "../../../components/_utils/CommonFileUpload";
import OwnerAccountPopUp from "../../../components/Accounts/OwnerAccountPopUp";
import { uploadFile } from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import ICONS from "../../../assets/Icons/index.js";
import AssignLabels from "../../../components/_utils/AccountCreationComponents/AssignLabels";
import SVGComponent from "../../../components/_utils/SVGComponent";
import SingleSelectDropDownComponentWithIcon from "../../../components/_utils/CommonDropdown/SingleSelectDropdownWithIcon/index.jsx";
import useCategories from "../../../utils/useCategories.js";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import SourceDestinationAccountDetail from "../../../components/_utils/TransactionCommonComponents/SourceDestinationAccountDetail/index.jsx";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import TEXT from "../../../utils/globalText";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import CommonLayout from "../../../components/_utils/CommonLayout/index.jsx";
import { toast } from "react-toastify";
import Loader from "../../../components/Loader/Index.jsx";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import PrivateTxnViewAll from "../PrivateTxnViewAll/index.jsx";

const DOWNLOAD_SAMPLE_ICON =
  "https://q2pay.in/new_assets/common/view_all/download_statement.svg";

const ARROW_LEFT_WHITE = ICONS.ARROW_LEFT_WHITE;

const NUM_STEPS = GlobalConfiguration?.lengthCheckThree;

const STEPPER_STEPS = [
  "Upload file",
  "Source account",
  "Confirm and upload file",
];

const PrivateTxnCreate = () => {
  const categoryMapper = useCategories();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSubmitting = useRef(false);
  const { isTransCateLoading } = useSelector(
    (state) => state.beneAllVerification,
  );
  const { allPrivateTransactionsLoading, createPrivateTransactionLoading } =
    useSelector((state) => state.privatetransactions);
  const [activeStepperStep, setActiveStepperStep] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedOwnerAccount, setSelectedOwnerAccount] = useState(null);
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);

  const [allCategories, setAllCategories] = useState(null);
  const [ownerPopupOpen, setOwnerPopupOpen] = useState(false);
  const [labelPopupOpen, setLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState(() => {
    const stored = sessionStorage.getItem("AvailableLabelsOwner");
    if (!stored) return [];
    try {
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  });

  const [selectedLabels, setSelectedLabels] = useState([]);
  const [enableConfirm, setEnableConfirm] = useState(true);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);

  const step0Done = !Array.isArray(selectedFile) && selectedCategory !== "";

  const downloadSample = () => {
    dispatch(getPrivateSampleCsv({ category: selectedCategory.label }));
  };

  const buildDuplicateCheckPayload = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    owner_account_id: selectedOwnerAccount?.ownerId,
    category: selectedCategory?.label,
  });

  const createPvtTxn = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;

    try {
      let { payload, type } = await dispatch(
        uploadFile({ file: selectedFile }),
      );
      if (type === "uploadFile/fulfilled") {
        let response = await dispatch(
          createPrivateTransaction({
            category: selectedCategory.label,
            owner_account_id: selectedOwnerAccount.ownerId,
            uploaded_file_data: payload,
            labels: selectedLabels,
          }),
        );
        if (response.payload.status === true) {
          navigate("success", {
            state: {
              ownerDetail: selectedOwnerAccount,
              labels: selectedLabels,
              file: selectedFile,
              category: selectedCategory,
              txn: response.payload.request_reference_id,
            },
          });
        } else {
          navigate("error", {
            state: {
              message:
                response?.payload?.data?.errors?.base?.[0] ??
                "An unknown error occurred",
            },
          });
        }
      } else {
        setEnableConfirm(true);
        CommonToast({
          variant: "var(--error)",
          text: "Something went wrong while uploading file",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
        });
      }
    } finally {
      isSubmitting.current = false;
    }
  };

  function getCurrentStep(step) {
    switch (step) {
      case 0: {
        return (
          <>
            <div
              className={`w-width-full Qlg:px-padding-base pt-padding-lg px-padding-md max-w-tab-width-normal`}
            >
              <CommonLayout>
                <div className="w-auto bg-primary-card rounded-border-radius-md p-padding-md flex flex-col gap-gap-md">
                  <div className="flex flex-col gap-gap-xs text-text-primary font-semibold">
                    <div className="text-font-md">
                      {TEXT.TRANSACTION_CATEGORY}
                    </div>
                    <div className="text-font-xs font-normal">
                      {TEXT.PRIVATE_TXN_STEP0_SELECT_TO_UPLOAD}
                    </div>
                  </div>
                  <div>
                    <SingleSelectDropDownComponentWithIcon
                      defaultIcon="https://q2pay.in/new_assets/common/settings/category_setup.svg"
                      options={
                        allCategories &&
                        allCategories.map((x) => {
                          return {
                            label: x.name,
                            icon: categoryMapper(x.name),
                          };
                        })
                      }
                      placeholder="Select"
                      searchPlaceholder="Search"
                      type="big"
                      showSearch={true}
                      selected={selectedCategory}
                      setSelected={setSelectedCategory}
                      disabled={
                        !Array.isArray(selectedFile) || isTransCateLoading
                      } // absurd!
                      defaultIconColor="var(--primary-bg)"
                    />
                  </div>
                  <div className="text-text-primary text-font-xs flex flex-col gap-gap-xs">
                    <p>Note:</p>
                    <ul className="list-disc list-outside ml-margin-md">
                      <li>{TEXT.PRIVATE_TXN_STEP0_NOTE1}</li>
                      <li>{TEXT.PRIVATE_TXN_STEP0_NOTE2}</li>
                    </ul>
                  </div>
                  <div className="w-full flex flex-row justify-end">
                    <PrimaryWithIconButton
                      btnText="Sample file"
                      btnType="button"
                      enabledBgColor="var(--emphasis)"
                      hoverOption="white"
                      iconToBeAlign="left"
                      icon={DOWNLOAD_SAMPLE_ICON}
                      enabledTextColor="var(--text-primary)"
                      isDisabled={!selectedCategory}
                      handleFunction={(e) => {
                        if (selectedCategory) downloadSample();
                      }}
                    />
                  </div>
                </div>

                <div className="w-auto flex flex-col  text-text-primary bg-primary-card rounded-border-radius-md p-padding-md gap-gap-md">
                  <div className="font-semibold text-font-md">
                    {TEXT.UPLOAD_FILE}
                  </div>
                  <div>
                    <CommonFileUpload
                      files={selectedFile}
                      setFiles={setSelectedFile}
                      isDisabled={selectedCategory === ""}
                      type="custom"
                      customExtensions={[".xls", ".xlsx", ".csv"]}
                    />
                  </div>
                  <div className="text-font-xs flex flex-col gap-gap-xs">
                    <p>{TEXT.FILE_VERIFICATION_PROCESS_POST_UPLOAD}</p>
                    <ul className="list-outside list-disc ml-margin-md">
                      <li>{TEXT.FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG1}</li>
                      <li>{TEXT.FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG2}</li>
                      <li>{TEXT.FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG3}</li>
                      <li>{TEXT.FILE_VERIFICATION_PROCESS_POST_UPLOAD_MSG4}</li>
                    </ul>
                  </div>
                </div>
              </CommonLayout>
            </div>
          </>
        );
      }
      case 1:
        return (
          <>
            {allPrivateTransactionsLoading && (
              <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-max  bg-PopUp-BackDrop opacity-dark-opacity">
                <div>
                  <Loader type={"bulk_upload"} />
                  <p className=" font-semibold text-font-lg text-text-primary">
                    Validating the data
                  </p>
                </div>
              </div>
            )}
            <div className="w-full Qlg:w-totp-box-width">
              <div className="flex flex-col gap-gap-md w-auto m-margin-md Qlg:ml-margin-base ml-margin-md Qmd:mt-margin-lg mt-margin-md">
                <div className="Qlg:w-totp-box-width w-full z-z-index-content">
                  <SourceDestinationAccountDetail
                    type="source"
                    modalOpen={ownerPopupOpen}
                    setModalOpen={setOwnerPopupOpen}
                    txnPayLoad={selectedOwnerAccount}
                    setTxnPayLoad={setSelectedOwnerAccount}
                    handleOnAccountSelection={() => {}}
                  />
                </div>

                {selectedOwnerAccount && (
                  <div className="Qlg:w-totp-box-width w-auto flex flex-col gap-gap-md bg-primary-card rounded-border-radius-md">
                    <AssignLabels
                      labels={selectedLabels}
                      setLabelpopup={setLabelPopupOpen}
                      subText1={TEXT.PRIVATE_TXN_LABELS_USAGE_NOTE}
                      subText2={TEXT.PRIVATE_TXN_LABELS_AUTO_ASSIGNED_NOTE}
                      isOptional={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        );
      case 2:
        return (
          <div
            className={`w-width-full flex flex-col Qlg:px-padding-base pt-padding-lg px-padding-md gap-gap-md max-w-tab-width-normal`}
          >
            <CommonLayout>
              <SourceDestinationAccountDetail
                type="source"
                modalOpen={ownerPopupOpen}
                setModalOpen={setOwnerPopupOpen}
                txnPayLoad={selectedOwnerAccount}
                setTxnPayLoad={setSelectedOwnerAccount}
                handleOnAccountSelection={() => {}}
                page="confirm"
              />

              <div className="w-auto  flex flex-col  text-text-primary h-full bg-primary-card rounded-border-radius-md p-padding-md gap-gap-md">
                <div className="font-semibold text-font-md">
                  {TEXT.UPLOAD_FILE}
                </div>

                <div>
                  <CommonFileUpload
                    files={selectedFile}
                    setFiles={setSelectedFile}
                    isDisabled={selectedCategory === ""}
                    readOnly
                  />
                </div>
              </div>

              {selectedOwnerAccount && (
                <div className="w-auto flex flex-col gap-gap-md bg-primary-card  rounded-border-radius-md ">
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-gap-xs justify-center text-text-primary pl-padding-md pt-padding-md">
                      <div className="text-text-primary font-semibold text-font-md">
                        {TEXT.TRANSACTION_CATEGORY}
                      </div>
                    </div>
                    <div className="h-auto"></div>
                  </div>
                  <div className="px-padding-md pb-padding-md">
                    <TitleSubtitlePair
                      subtitle={"Category"}
                      title={selectedCategory.label}
                      variant="md"
                      titleColor="text-secondary"
                    />
                  </div>
                </div>
              )}

              {selectedOwnerAccount && (
                <div className="w-auto flex flex-col gap-gap-md bg-primary-card  rounded-border-radius-md ">
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-col gap-gap-xs justify-center text-text-primary pl-padding-md pt-padding-md">
                      <div className="text-text-primary font-semibold text-font-md">
                        {TEXT.LABELS}{" "}
                        <span className="font-normal">(Optional)</span>
                      </div>
                      <div className="text-text-secondary text-font-xs">
                        {TEXT.PRIVATE_TXN_LABELS_USAGE_NOTE}
                      </div>
                    </div>
                    <div className="h-auto"></div>
                  </div>
                  <div className="px-padding-md pb-padding-md">
                    <TitleSubtitlePair
                      subtitle={TEXT.LABELS}
                      title={
                        selectedLabels.length !==
                        GlobalConfiguration.lengthCheckZero
                          ? selectedLabels.join(", ")
                          : "Not assigned"
                      }
                      variant="md"
                      titleColor="text-secondary"
                    />
                  </div>
                </div>
              )}
            </CommonLayout>
          </div>
        );
      default:
        return (
          <>
            <div className="w-totp-box-width h-navbar-breadcrumb-height bg-white"></div>
            <div className="w-totp-box-width h-navbar-breadcrumb-height bg-white"></div>
          </>
        );
    }
  }
  const popupLabels = React.useMemo(() => {
    if (!Array.isArray(labels)) return [];
    return labels.filter((label) => !/[A-Z]/.test(label || ""));
  }, [labels]);
  const id = (x) => x;
  useEffect(() => {
    (async () => {
      // PLogin
      const response = await dispatch(beneCategories());
      if (response.payload.status) {
        setAllCategories(response.payload.categories);
      }
    })();
  }, []);
  useEffect(() => {
    const ownerLabels = selectedOwnerAccount?.ownerLabels ?? [];
    setSelectedLabels(ownerLabels);
    setLabels((prev) => {
      const prevList = Array.isArray(prev) ? prev : [];
      return [...new Set([...prevList, ...ownerLabels])];
    });
  }, [selectedOwnerAccount]);
  return (
    <>
      {showSimilarModal && (
        <LargePopupRedirect
          headerTitle="Similar transactions found"
          isHeaderImgNeed={true}
          ShowIcon={ICONS.ALERT}
          headersubtext="Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
          closeiconenabledBgColor="var(--primary-nav)"
          closeiconisLoading={false}
          closeiconhandleFunction={() => setShowSimilarModal(false)}
          closeicon={"https://q2pay.in/new_assets/common/create_flow/close.svg"}
          closeiconhoverOption="white"
          closeiconbtnType={"button"}
          closeiconisDisabled={false}
          closeicondisabledBgColor={""}
          closeiconbuttonRef={null}
          closeicontitle={"Close"}
          btnType={"button"}
          confirmbtnrequired={true}
          enabledBgColor={"var(--negative-act)"}
          hoverOption={"dark"}
          enabledTextColor={"var(--text-primary)"}
          fullWidthRequired={false}
          isbottomSectionneed={true}
          bottomHeaderTextNeed={true}
          btnText="Proceed with caution"
          isDisabled={createPrivateTransactionLoading}
          isLoaderNeeded={true}
          isLoading={createPrivateTransactionLoading}
          disabledBgColor={
            createPrivateTransactionLoading
              ? "var(--negative-act)"
              : "var(--text-disabled)"
          }
          handleFunction={(e) => {
            e.stopPropagation();
            createPvtTxn();
          }}
          bottomHeaderText={"Proceed with creating this transaction?"}
        >
          <PrivateTxnViewAll
            type={"private_view_similar"}
            currentCat={selectedCategory?.label}
            owner_account_id={selectedOwnerAccount?.ownerId}
            owner_account_no={selectedOwnerAccount?.ownerBankAccountNo}
          />
        </LargePopupRedirect>
      )}
      <div className="z-z-index-modal">
        {ownerPopupOpen && (
          <OwnerAccountPopUp
            setTxnPayLoad={setSelectedOwnerAccount}
            setOpenOwner={setOwnerPopupOpen}
            setIsNeft={id}
            setIsImps={id}
            setIsRtgs={id}
            BenEnableNextButton={id}
            setpaymentBox={id}
            flow="createTxn"
          />
        )}
      </div>

      {labelPopupOpen && (
        <div className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={(finalLabels) => {
              setLabelPopupOpen(false);
              if (Array.isArray(finalLabels)) {
                setSelectedLabels(finalLabels);
              }
            }}
            closeisDisabled={false}
            labels={popupLabels}
            setLabels={setLabels}
            selectedLabelsCreate={selectedLabels}
            setSelectedLabelsCreate={setSelectedLabels}
            isLabelPopupOpen={labelPopupOpen}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            type="create"
          />
        </div>
      )}
      <div className="ptc-main-bg-div fixed top-top-base left-left-base w-full-width h-full-height bg-primary-bg z-z-index-base">
        <>
          <div className="ptc-navbar-padding-div Qmd:h-[calc(var(--navbar-breadcrumb-height)-2px)] h-auto block Qlg:bg-primary-bg Qmd:bg-primary-nav bg-transparent">
            <div className="Qsmd:hidden flex bg-primary-nav gap-gap-md h-full items-center p-padding-md shadow-box-shadow-bottom">
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  navigate("/private_transaction_dashboard");
                }}
              >
                <SVGComponent
                  url={ARROW_LEFT_WHITE}
                  color="var(--text-primary)"
                  height="var(--icon-md)"
                  width="var(--icon-md)"
                />
              </div>
              <div className="flex flex-col gap-gap-xs text-text-primary text-font-md">
                <div>{TEXT.CREATE_PRIVATE_TXN}</div>
                <div className="text-text-secondary text-font-xs">
                  {STEPPER_STEPS[activeStepperStep]}
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col h-full  pb-medium-screen-top-padding ">
            <div className="flex flex-row justify-center w-full-width Qsmd:relative absolute bottom-0 z-z-index-overlay">
              <div className="w-std-width mx-auto rounded-b-border-radius-md shadow-box-shadow-bottom relative min-h-stepper-height">
                <PrimaryStepper
                  activeStep={activeStepperStep}
                  handleForwardAction={async (e) => {
                    if (
                      activeStepperStep === GlobalConfiguration?.lengthCheckOne
                    ) {
                      // settxnLoading(true);
                      // setIsSubmitting(true);

                      let res = await dispatch(
                        getAllPrivateTransactions(buildDuplicateCheckPayload()),
                      );
                      const hasDuplicates =
                        res?.payload?.transaction_requests?.length >
                        GlobalConfiguration?.lengthCheckZero;

                      setSimilarTransaction(hasDuplicates);
                      // setIsSubmitting(false);

                      if (hasDuplicates) {
                        toast.dismiss();
                        CommonToast({
                          text: "Few issues found click check to view.",
                          icon: ICONS?.ERROR_WHITE_CIRCLE,
                          variant: "var(--error)",
                          btnProps: {
                            isDisabled: false,
                            enabledTextColor: "var(--text-primary)",
                            enabledBgColor: "var(--primary-bg)",
                          },
                        });
                      }
                    } else if (
                      activeStepperStep === GlobalConfiguration?.lengthCheckTwo
                    ) {
                      if (similarTransaction) {
                        setShowSimilarModal(true);
                      } else {
                        setEnableConfirm(false);
                        createPvtTxn();
                      }
                    }
                    setActiveStepperStep((as) =>
                      Math.min(as + 1, NUM_STEPS - 1),
                    );
                  }}
                  handleBackwardAction={(e) => {
                    if (activeStepperStep === 0)
                      navigate("/private_transaction_dashboard");
                    setActiveStepperStep((as) => Math.max(as - 1, 0));
                  }}
                  dataArray={[
                    {
                      previousText: "Cancel",
                      nextText: "Next",
                      previousEnableBgColor: "var(--primary-nav-act)",
                      nextEnableBgColor: "var(--text-primary)",

                      previousEnableTextColor: "var(--text-primary)",
                      previousDisableBgColor: "var(--primary-nav-act)",
                      nextEnableTextColor: "var(--primary-bg)",
                      nextDisableBgColor: "var(--text-disabled)",
                      nextDisableTextColor: "var(--text-primary)",
                      nextIsLoading: false,
                      nextIsEnabled: step0Done,
                      stepperText: STEPPER_STEPS[0],
                    },
                    {
                      previousText: "Previous",
                      nextText: "Next",
                      previousEnableBgColor: "var(--primary-nav-act)",
                      nextEnableBgColor: "var(--text-primary)",

                      previousEnableTextColor: "var(--text-primary)",
                      previousDisableBgColor: "var(--primary-nav-act)",
                      nextEnableTextColor: "var(--primary-bg)",
                      nextDisableBgColor: "var(--text-disabled)",
                      nextDisableTextColor: "var(--text-primary)",
                      nextIsLoading: false,
                      nextIsEnabled: selectedOwnerAccount,
                      stepperText: STEPPER_STEPS[1],
                    },
                    {
                      previousText: "Previous",
                      nextText: similarTransaction ? "Check" : "Confirm",
                      previousEnableBgColor: "var(--primary-nav-act)",
                      nextEnableBgColor: similarTransaction
                        ? "var(--emphasis)"
                        : "var(--positive-act)",

                      previousEnableTextColor: "var(--text-primary)",
                      previousDisableBgColor: "var(--primary-nav-act)",
                      nextEnableTextColor: "var(--text-primary)",
                      nextDisableBgColor: "var(--text-disabled)",
                      nextDisableTextColor: "var(--text-primary)",
                      nextIsLoading: false,
                      nextIsEnabled: enableConfirm,
                      stepperText: STEPPER_STEPS[2],
                    },
                  ]}
                />
              </div>
            </div>
            <div className="h-full overflow-y-scroll overflow-x-hidden w-full flex flex-col">
              <div className="ptc-main-content-div mx-auto  flex-1 Qlg:w-std-width w-full-width Qlg:items-start items-center Qlg:self-center self-auto flex Qlg:flex-row flex-col Qlg:gap-gap-md gap-gap-base Qlg:justify-between justify-start">
                {getCurrentStep(activeStepperStep)}
                <div className="h-[73px] Qlg:hidden block"></div>
              </div>
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default PrivateTxnCreate;
